<template>
  <el-container class="con">
    <!-- 头部内容 -->
    <el-header class="header">
      <div class="headerItem">
        <img class="logo" src="@/assets/global/uwell.png" alt="" />
        <span class="headerTitle">{{ $t("login.title") }}</span>
      </div>
      <div class="headerItem">
        <SelectLang />
        <HeaderUser :user-logout="userLogout" />
      </div>
    </el-header>
    <el-container>
      <!-- 侧边 -->
      <LayoutAside @change="getChange" />
      <!-- 主视窗 -->
      <el-main :class="{ main: true, collapsed: isCollapsed }">
        <router-view></router-view>
        <MoAsiede />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SelectLang from "@/components/SelectLang";
import HeaderUser from "@/components/HeaderUser";
import LayoutAside from "@/components/LayoutAside";
import MoAsiede from "@/components/MoAsiede";
import { getListCountry, getListProduct } from "@/api";

import { useStore } from "@/store";

export default {
  name: "UserContent",
  components: {
    SelectLang,
    HeaderUser,
    LayoutAside,
    MoAsiede,
  },
  props: {
    userLogout: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  mounted() {
    this.getCountry();
    this.getProduct(1);
  },
  methods: {
    async getCountry() {
      const res = await getListCountry();
      if (res?.success) {
        const list = res.data;
        useStore().setCountryList(list);
      }
    },
    renameKeysInArray(list) {
      let res = [];
      list.map((item) => {
        let renamedItem = {
          label: item.name,
          value: item.id,
        };
        let childrenList = [];
        item.productChildren.map((item) => {
          childrenList.push({
            label: item.productName,
            value: item.id,
          });
        });
        renamedItem.children = childrenList;
        res.push(renamedItem);
      });

      return res;
    },
    async getProduct(type) {
      const res = await getListProduct(type);
      if (res?.success) {
        let list = res?.data || [];
        const renamedArr = this.renameKeysInArray(list);
        useStore().setProductList(renamedArr);
      }
    },
    getChange(val) {
      this.isCollapsed = val;
    },
  },
};
</script>

<style lang="less" scoped>
.con {
  height: 100vh;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1300;
    width: 100%;
    padding: 0;
    background: #fff;
    border-bottom: 1px solid #dbe2ec;
    box-shadow: 0 0 4px 3px rgba(89, 138, 203, 0.12);
    padding: 0 20px;
    box-sizing: border-box;
    .logo {
      height: 35px;
      width: 35px;
      padding-right: 10px;
    }
    .headerItem {
      display: flex;
      align-items: center;
      color: rgba(80, 80, 80, 1);
      font-size: 14px;
      font-weight: bold;
    }
  }

  .aside {
    border-right: 1px solid #dbe2ec;
  }
  .main {
    // display: flex;
    background-color: #f2f3f7;
    padding-top: 60px;
    padding-left: 240px;
    transition: all 0.25s linear;
  }
  :deep(.el-main) {
    padding-right: 0;
  }
  .collapsed {
    padding-left: 64px;
  }

  @media (max-width: 992px) {
    .header {
      padding: 0 17px;
      .logo {
        height: 44px;
        width: 44px;
        padding-right: 10px;
      }
      .headerTitle {
        display: none;
      }
    }
    .main {
      padding-left: 0;
    }
  }
}
</style>
